import { render, staticRenderFns } from "./SplashScreen.vue?vue&type=template&id=73c97e83&scoped=true&"
import script from "./SplashScreen.vue?vue&type=script&lang=js&"
export * from "./SplashScreen.vue?vue&type=script&lang=js&"
import style0 from "./SplashScreen.vue?vue&type=style&index=0&id=73c97e83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c97e83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73c97e83')) {
      api.createRecord('73c97e83', component.options)
    } else {
      api.reload('73c97e83', component.options)
    }
    module.hot.accept("./SplashScreen.vue?vue&type=template&id=73c97e83&scoped=true&", function () {
      api.rerender('73c97e83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/game/sunset-drive/components/SplashScreen.vue"
export default component.exports